export const CourseLeaderBoardTableHeader = [
  { name: 'index', label: '', isSortable: false, align: 'right' },
  { name: 'title', label: 'نام و نام خانوادگی', isSortable: true, align: 'center' },
  { name: 'createdAt', label: 'سطح', isSortable: false, align: 'center' },
  { name: 'createdAt', label: 'شماره تماس', isSortable: false, align: 'center' },
  { name: 'createdAt', label: 'تعداد دوره گذرانده', isSortable: false, align: 'center' },
  { name: 'createdAt', label: 'مجموع امتیازات', isSortable: false, align: 'center' },
];
